import { Injectable } from '@angular/core';

import { IntegrationsApiService } from '@recruitee/integrations-http';
import { IntegrationKinds } from '@recruitee/integrations-types';

@Injectable({ providedIn: 'root' })
export class HotelprofessionalsApiService extends IntegrationsApiService {
  public context: string = IntegrationKinds.HOTELPROFESSIONALS;
}
